module.exports = __webpack_public_path__ + "static/media/AppIcon-TOI700d.7b5c2313.png";